import Vue from 'vue';
import Vuetify from 'vuetify';
import Axios from 'axios';
import * as VueGoogleMaps from 'vue2-google-maps';
import { sync } from 'vuex-router-sync';
import VueTrix from 'vue-trix';

import App from './App.vue';
import router from './router';
import store from './store';

import vuetifyConfig from '@/configs/vuetifyConfig';
import Load from '@/configs/gMapsConfig/load';

import 'material-design-icons-iconfont/dist/material-design-icons.css';

import './registerServiceWorker';
import './stylesheets/app.styl';

Vue.config.productionTip = false;

Vue.use(Vuetify, vuetifyConfig);
Vue.use(VueGoogleMaps, Load);
Vue.use(VueTrix);

Axios.defaults.baseURL = process.env.VUE_APP_API_BASE_URL;
Axios.defaults.headers.common.Accept = 'application/json';
Axios.defaults.headers.common['x-xdesign-platform'] = 'cms';

if (localStorage.getItem('token') !== null) {
  Axios.defaults.headers.common.Authorization = `Bearer ${localStorage.getItem('token')}`;
}

Axios.interceptors.response.use(
  (response) => response,
  (error) => {
    if (error.response.status === 500) {
      // TODO: Internal Server Error Handler
    }
    return Promise.reject(error);
  },
);

export const currentAppVersion = process.env.VUE_APP_VERSION;

export const $http = Axios;

Object.defineProperty(Vue.prototype, '$http', {
  get() {
    return Axios;
  },
});

router.beforeEach((to, from, next) => {
  if (to.meta.auth) {
    if (localStorage.getItem('token') === null) {
      next({
        name: 'login',
      });
    } else {
      next();
    }
  } else {
    next();
  }
});

export const $router = router;

sync(store, router);

new Vue({
  router,
  store,
  render: (h) => h(App),
}).$mount('#app');
